export enum ResourceType {
	COINS = "coins",
	GEMS = "gems",
	LUMBER = "lumber",
	STONE = "stone",
	CLAY = "clay",
	IRON = "iron",
	GOODS = "goods",
	STEEL = "steel",
	ARMY = "army",
	RATIONS = "rations",
	EVENTIUM = "eventium",

	FOOD_DIFF = "foodDiff",
	POPULATION_DIFF = "populationDiff", // same as workforce

	// clickers and skippers
	SUPER_CLICKER = "superClicker",
	CLICKER_2 = "clicker2",
	CLICKER_3 = "clicker3",
	CLICKER_5 = "clicker5",
	AD_SKIPPER = "adSkipper",

	// TODO: rename to *_PRODUCTION
	COINS_INCOME = "coinsIncome",
	LUMBER_INCOME = "lumberIncome",
	STONE_INCOME = "stoneIncome",
	CLAY_INCOME = "clayIncome",
	IRON_INCOME = "ironIncome",
	GOODS_INCOME = "goodsIncome",
	STEEL_INCOME = "steelIncome",
	ARMY_INCOME = "armyIncome",
	RATIONS_INCOME = "rationsIncome",
	EVENTIUM_INCOME = "eventiumIncome",

	FOOD_INCOME = "foodIncome",
	POPULATION_INCOME = "populationIncome",

	// income without storage cap - for settlement quests only
	COINS_UNCAPPED_INCOME = "coinsUncappedIncome",
	LUMBER_UNCAPPED_INCOME = "lumberUncappedIncome",
	STONE_UNCAPPED_INCOME = "stoneUncappedIncome",
	CLAY_UNCAPPED_INCOME = "clayUncappedIncome",
	IRON_UNCAPPED_INCOME = "ironUncappedIncome",
	GOODS_UNCAPPED_INCOME = "goodsUncappedIncome",
	STEEL_UNCAPPED_INCOME = "steelUncappedIncome",
	ARMY_UNCAPPED_INCOME = "armyUncappedIncome",
	RATIONS_UNCAPPED_INCOME = "rationsUncappedIncome",
	EVENTIUM_UNCAPPED_INCOME = "eventiumUncappedIncome",
	EVENTIUM_UNCAPPED_INCOME_WITHOUT_PENALTIES = "eventiumUncappedIncomeWithoutPenalties",
	EVENTIUM_ACCUMULATED = "eventiumAccumulated",

	FOOD_CONSUMPTION = "foodConsumption",
	POPULATION_CONSUMPTION = "populationConsumption",
	LUMBER_CONSUMPTION = "lumberConsumption",
	STONE_CONSUMPTION = "stoneConsumption",
	CLAY_CONSUMPTION = "clayConsumption",
	IRON_CONSUMPTION = "ironConsumption",
	GOODS_CONSUMPTION = "goodsConsumption",
	STEEL_CONSUMPTION = "steelConsumption",
	ARMY_CONSUMPTION = "armyConsumption",
	RATIONS_CONSUMPTION = "rationsConsumption",
	EVENTIUM_CONSUMPTION = "eventiumConsumption",

	// internal
	FISH_INCOME = "fishIncome", // produces FOOD

	// analytic resources
	COINS_PLUS = "coinsPlus",
	COINS_MINUS = "coinsMinus",
	GEMS_PLUS = "gemsPlus",
	GEMS_MINUS = "gemsMinus",
	CLICKER_2_PLUS = "clicker2Plus",
	CLICKER_2_MINUS = "clicker2Minus",
	CLICKER_3_PLUS = "clicker3Plus",
	CLICKER_3_MINUS = "clicker3Minus",
	CLICKER_5_PLUS = "clicker5Plus",
	CLICKER_5_MINUS = "clicker5Minus",
	SUPER_CLICKER_PLUS = "superClickerPlus",
	SUPER_CLICKER_MINUS = "superClickerMinus",
	AD_SKIPPER_PLUS = "adSkipperPlus",
	AD_SKIPPER_MINUS = "adSkipperMinus",
	ADS_WATCHED_TOTAL = "adsWatchedTotal",
	TICKS_TOTAL = "ticksTotal",
	CLICKS_TOTAL = "clicksTotal",
	CLICKS_CASTLE_TOTAL = "clicksCastleTotal",
	CLICKS_EXPLORATION_TOTAL = "clicksExplorationTotal",
	EVENTIUM_PLUS = "eventiumPlus",
	EVENTIUM_MINUS = "eventiumMinus",

	// internal
	LEVEL = "level", // TODO: premenovat na MAIN_LEVEL
	// EARLY_ACCESS_LEVEL = "earlyAccessLevel",
	SETTLEMENT_LEVEL = "settlementLevel",
	SETTLEMENT_CONNECTION = "settlementConnection",
	SETTLEMENT_CLICKS = "settlementClicks",
	EXPLORATION_SPEED = "explorationSpeed",

	// piggy bank
	PIGGY_BANK_PROGRESS = "piggyBankProgress",

	// buildings refactor
	PRODUCTION_RESOURCE_UNIT = "productionResourceUnit",
	PRODUCTION_RESOURCE_MULTIPLIER = "productionResourceMultiplier",
	PRODUCTION_ONCLICK_RESOURCE_MULTIPLIER = "productionOnclickResourceMultiplier",
	STORAGE_RESOURCE_MULTIPLIER = "storageResourceMultiplier",

	// Offer resource multiplier
	COINS_MULTIPLIER = "coinsMultiplier",

	// Event market
	CHEST_KEY = "chestKey",
}
